const ROME_TIME_ZONE = "Europe/Rome";

const ISO_LOCAL_WITHOUT_OFFSET = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;

function parseBackendUtcInstant(raw) {
  if (raw == null) {
    return null;
  }
  if (raw instanceof Date) {
    return Number.isNaN(raw.getTime()) ? null : raw;
  }
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (!trimmed) {
      return null;
    }
    if (ISO_LOCAL_WITHOUT_OFFSET.test(trimmed) && !/[Zz]|[+-]\d{2}:\d{2}$/.test(trimmed)) {
      return new Date(`${trimmed}Z`);
    }
    const parsed = new Date(trimmed);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  if (Array.isArray(raw) && raw.length >= 3) {
    const [year, month, day, hour = 0, minute = 0, second = 0, nano = 0] = raw;
    const milliseconds = nano ? Math.floor(Number(nano) / 1_000_000) : 0;
    return new Date(Date.UTC(year, month - 1, day, hour, minute, second, milliseconds));
  }
  return null;
}

export function formatVendorDateTimeRome(raw, pattern = "DD/MM/YYYY HH:mm") {
  const instant = parseBackendUtcInstant(raw);
  if (!instant) {
    return "";
  }

  if (pattern === "DD/MM/YYYY HH:mm") {
    return new Intl.DateTimeFormat("it-IT", {
      timeZone: ROME_TIME_ZONE,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(instant);
  }

  return new Intl.DateTimeFormat("it-IT", {
    timeZone: ROME_TIME_ZONE,
    dateStyle: "short",
    timeStyle: "short",
    hour12: false,
  }).format(instant);
}

export function formatVendorCaricamentoDate(raw) {
  const instant = parseBackendUtcInstant(raw);
  if (!instant) {
    return "--";
  }

  const day = new Intl.DateTimeFormat("it-IT", {
    timeZone: ROME_TIME_ZONE,
    day: "numeric",
  }).format(instant);
  const month = new Intl.DateTimeFormat("it-IT", {
    timeZone: ROME_TIME_ZONE,
    month: "short",
  }).format(instant);
  const formattedMonth = month.charAt(0).toUpperCase() + month.slice(1);
  const formattedTime = new Intl.DateTimeFormat("it-IT", {
    timeZone: ROME_TIME_ZONE,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(instant);

  return `${day} ${formattedMonth} - Ore ${formattedTime}`;
}

export { parseBackendUtcInstant, ROME_TIME_ZONE };
